import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, classNames, Flex, FlexColumn, Item, ItemContent, ItemDescription, ItemSide, ItemTitle, Separator, SkeletonBlock, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { ActionTimelineSkeleton } from "../../../components/ActionTimeline/ActionTimelineSkeleton";
export function CollectionSweepFlowSkeleton(t0) {
  const $ = _c(36);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  const t = useTranslations("wallet.CollectionSweepFlow");
  let t2;
  if ($[0] !== t) {
    t2 = t("title");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <BottomSheetHeader><BottomSheetHeaderTitle>{t2}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== count) {
    t4 = new Array(count).fill(0).map(_temp);
    $[4] = count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <FlexColumn className="max-h-36 overflow-y-auto">{t4}</FlexColumn>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator className="my-2" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("total");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <ItemContent><ItemTitle><ItemTitle>{t7}</ItemTitle></ItemTitle></ItemContent>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ItemTitle><SkeletonBlock className="h-4 w-16" /></ItemTitle>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ItemSide className="items-end">{t9}<ItemDescription className="mt-1.5"><SkeletonBlock className="h-4 w-10" /></ItemDescription></ItemSide>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t8) {
    t11 = <Item className="py-4" variant="unstyled">{t8}{t10}</Item>;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t5) {
    t12 = <FlexColumn className="w-full">{t5}{t6}{t11}</FlexColumn>;
    $[17] = t11;
    $[18] = t5;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator className="hidden h-auto md:block" orientation="vertical" />;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t) {
    t14 = t("paymentMethod");
    $[21] = t;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <TextBody className="mb-4 uppercase" color="text-secondary" size="xs" weight="semibold">{t14}</TextBody>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  let t17;
  let t18;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SkeletonBlock className="h-20 w-full rounded" />;
    t17 = <Separator className="my-6" />;
    t18 = <ActionTimelineSkeleton count={1} />;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t16 = $[25];
    t17 = $[26];
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t15) {
    t19 = <FlexColumn className="w-full min-w-0">{t15}{t16}{t17}{t18}</FlexColumn>;
    $[28] = t15;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t12 || $[31] !== t19) {
    t20 = <BottomSheetBody className="mt-2 pb-2"><Flex className="size-full flex-col gap-10 md:flex-row">{t12}{t13}{t19}</Flex></BottomSheetBody>;
    $[30] = t12;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t20 || $[34] !== t3) {
    t21 = <>{t3}{t20}</>;
    $[33] = t20;
    $[34] = t3;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  return t21;
}
function _temp(_, i) {
  return <Item className="py-4" key={i} variant="unstyled"><SkeletonBlock className={classNames("order-1 size-12 shrink-0 rounded text-primary")} /><ItemContent><ItemTitle><SkeletonBlock className="h-4 w-16" /></ItemTitle></ItemContent><ItemSide className="items-end"><ItemTitle><SkeletonBlock className="h-4 w-16" /></ItemTitle><ItemDescription className="mt-1.5"><SkeletonBlock className="h-4 w-10" /></ItemDescription></ItemSide></Item>;
}